import { Injectable } from '@angular/core';
import { BaseSearchStrategy } from './base-strategy';
import { SearchableItem } from '../models/searchable-item.model';
import {
  ScoredMatch,
  StrategyContext,
  StrategyId,
} from '../models/search-strategy.model';
import { ngramSimilarity } from '../utils/fuzzy-search.utils';

@Injectable({ providedIn: 'root' })
export class NGramMatchStrategy extends BaseSearchStrategy {
  readonly id: StrategyId = 'ngram';
  readonly defaultWeight = 100;
  private readonly threshold = 0.3;

  override score<T>(
    item: SearchableItem<T>,
    ctx: StrategyContext
  ): ScoredMatch | null {
    const haystack = `${this.normalizedTitle(item)} ${this.normalizedDescription(item)}`;
    const sim = ngramSimilarity(ctx.normalizedQuery, haystack);
    if (sim <= this.threshold) return null;
    return this.match(this.id, sim * this.defaultWeight, `ngram=${sim.toFixed(2)}`);
  }
}
